// ----------------------------------------------------- Receiver Location Pages
import ReceiverLocationListPage from '../pages/receiverUi/receiverLocations/ReceiverLocationListPage.vue'

// -------------------------------------------------------- Receiver Order Pages
import ReceiverOrderListPage from '../pages/receiverUi/orders/ReceiverOrderListPage.vue'
import ReceiverOrderInfoRootPage from '../pages/receiverUi/orders/ReceiverOrderInfoRootPage.vue'
import ReceiverOrderInfoSummary from '../pages/receiverUi/orders/ReceiverOrderInfoSummary.vue'
import ReceiverOrderInfoTrackingHistory from '../pages/receiverUi/orders/ReceiverOrderInfoTrackingHistory.vue'
import ReceiverOrderInfoAttachmentDocs from '../pages/receiverUi/orders/ReceiverOrderInfoAttachmentDocs.vue'
import ReceiverOrderInfoMessages from '../pages/receiverUi/orders/ReceiverOrderInfoMessages.vue'

// ------------------------------------------------------- Receiver Credit Pages
import ReceiverCreditListPage from '../pages/receiverUi/credits/ReceiverCreditListPage.vue'

const routes = [
  // ------------------------------------------------- Manage Receiver Locations
  {
    path: '/receiver-locations',
    name: 'receiver-ui-receiver-location-list',
    component: ReceiverLocationListPage,
    props: true,
    meta: {
      requiresAuth: true,
      ui_type: ['receiver']
    }
  },
  // {
  //   path: '/admin/receiver/:receiverId',
  //   component: ReceiverRootPage,
  //   props: true,
  //   meta: { requiresAuth: true },
  //   children: [
  //     {
  //       path: '/',
  //       name: 'receiver-item',
  //       component: ReceiverItemPage,
  //       props: true
  //     },
  //     {
  //       path: 'edit',
  //       name: 'receiver-item-edit',
  //       component: ReceiverItemEditPage,
  //       props: true
  //     },
  //     {
  //       path: '*',
  //       redirect: '/admin/receivers'
  //     }
  //   ]
  // }

  // --------------------------------------------------------------- View Orders
  {
    path: '/receiver-orders',
    name: 'receiver-order-list',
    component: ReceiverOrderListPage,
    props: true,
    meta: {
      requiresAuth: true,
      ui_type: ['receiver']
    }
  },
  {
    path: '/receiver-order/:orderId',
    component: ReceiverOrderInfoRootPage,
    props: true,
    meta: {
      requiresAuth: true,
      ui_type: ['receiver']
    },
    children: [
      {
        path: 'summary',
        name: 'receiver-order-info-summary',
        component: ReceiverOrderInfoSummary,
        props: true
      },
      {
        path: 'tracking-history',
        name: 'receiver-order-info-tracking-history',
        component: ReceiverOrderInfoTrackingHistory,
        props: true
      },
      {
        path: 'attachment-docs',
        name: 'receiver-order-info-attachment-docs',
        component: ReceiverOrderInfoAttachmentDocs,
        props: true
      },
      {
        path: 'messages',
        name: 'receiver-order-info-messages',
        component: ReceiverOrderInfoMessages,
        props: true
      },
      {
        path: '*',
        redirect: '/receiver-order/:orderId'
      }
    ]
  },

  // -------------------------------------------------------------- View Credits
  {
    path: '/receiver-credits',
    name: 'receiver-credit-list',
    component: ReceiverCreditListPage,
    props: true,
    meta: {
      requiresAuth: true,
      ui_type: ['receiver']
    }
  }
]

export default routes
